import type { SchemaOf } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';

export interface IOrganisationAddress {
  addressLine1: string;
  addressLine2?: string;
  state?: string;
  postalCode: string;
  country: string;
}

export const organisationAddressSchemaMap: SchemaOf<IOrganisationAddress> = {
  addressLine1: Joi.string().required(),
  addressLine2: Joi.string(),
  state: Joi.string(),
  postalCode: Joi.string().required(),
  country: Joi.string().required(),
};

export const organisationAddressSchema = objectSchemaOf<IOrganisationAddress>(
  organisationAddressSchemaMap
);

export interface IOrganisation {
  contactEmail: string;
  contactName: string;
  contactNumber?: string;
  organisationId: string;
  organisationName: string;
  logoUrl?: string;
  abn?: string;
  address?: IOrganisationAddress;
  security?: {
    contactName: string;
    contactNumber: string;
  };
  notes?: string;
  isMultiTenant?: boolean;
}
